var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdDigitalPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 6,
    fill: "url(#paint0_linear_1901_2616)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.245 13.638 L 3.424 13.638 L 3.424 5.384 L 8.186 5.384 L 8.186 6.338 L 4.703 6.338 L 4.703 8.864 L 8.013 8.864 L 8.013 9.819 L 4.703 9.819 L 4.703 12.683 L 8.245 12.683 L 8.245 13.638 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.114 12.659 L 13.118 12.664 L 13.123 12.669 C 13.207 12.749 13.308 12.793 13.426 12.793 C 13.541 12.793 13.644 12.749 13.72 12.664 C 13.802 12.581 13.842 12.478 13.842 12.363 L 13.842 9.793 L 16.513 9.793 C 16.632 9.793 16.74 9.754 16.825 9.673 C 16.919 9.592 16.972 9.486 16.972 9.363 C 16.972 9.243 16.915 9.144 16.821 9.075 C 16.734 8.997 16.63 8.959 16.513 8.959 L 13.842 8.959 L 13.842 6.376 C 13.842 6.263 13.803 6.16 13.723 6.078 C 13.651 5.986 13.55 5.932 13.426 5.932 C 13.3 5.932 13.195 5.988 13.115 6.078 L 13.115 6.079 L 13.114 6.079 C 13.041 6.164 13.009 6.266 13.009 6.376 L 13.009 8.959 L 10.34 8.959 C 10.22 8.959 10.11 8.999 10.02 9.075 C 9.927 9.148 9.881 9.248 9.881 9.363 C 9.881 9.475 9.926 9.576 10.001 9.661 L 10.008 9.669 L 10.019 9.677 C 10.11 9.753 10.219 9.793 10.34 9.793 L 13.009 9.793 L 13.009 12.363 C 13.009 12.472 13.041 12.574 13.114 12.659 Z",
    fill: "white",
    style: {}
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1901_2616",
    x1: 0.747991,
    y1: 0.582667,
    x2: 17.6217,
    y2: 18.4173,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.055556, 0, 0, 1.021525, -0.527778, -0.20466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4100"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdDigitalPlus);
export default __webpack_public_path__ + "static/media/ed-digital-plus.c7b5b4487fe718227d6fa2a1ff7b7b03.svg";
export { ForwardRef as ReactComponent };